import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const Reveal = ({ children, delay = 0, className = "", y = 24 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false, className = "" }) => (
  <p className={`font-mono text-xs font-semibold uppercase tracking-[0.2em] ${dark ? "text-violet-400" : "text-accent"} ${className}`}>
    {children}
  </p>
);

export const SectionHead = ({ eyebrow, title, lead, dark = false, align = "left" }) => (
  <div className={`${align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}`}>
    <Reveal>
      <Eyebrow dark={dark}>{eyebrow}</Eyebrow>
      <h2 className={`mt-4 font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl ${dark ? "text-white" : "text-charcoal-900"}`}>
        {title}
      </h2>
      {lead && <p className={`mt-4 text-base leading-relaxed ${dark ? "text-slate-300" : "text-steel"}`}>{lead}</p>}
    </Reveal>
  </div>
);

export const ArrowLink = ({ to, children, dark = false }) => (
  <Link
    to={to}
    data-testid={`arrow-link-${to.replace("/", "") || "home"}`}
    className={`group inline-flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-[0.15em] ${dark ? "text-violet-400" : "text-accent"}`}
  >
    {children}
    <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
  </Link>
);

export default Reveal;
